/**
 * The names a code editor may suggest.
 *
 * Which names a screen offers is a rule about the game rather than about
 * CodeMirror, so it lives here where it can be tested without a document: the
 * level editor offers the level's own slots and everything defined in this
 * chapter or an earlier one, and the sandbox offers the whole library.
 */

/** One name to offer, with what the list should say about it. */
export interface Suggestion {
  /** The name itself, as it is written. */
  name: string;
  /** Shown beside the name in the completion list. */
  detail?: string;
  /** Lower ranks sort first; names of equal rank sort by name. */
  rank?: number;
  /** Whether the name resolves today, which is what the editor highlights. */
  defined?: boolean;
}

/** Orders suggestions for the completion list: slots first, then by name. */
export function compareSuggestions(left: Suggestion, right: Suggestion): number {
  const rank = (left.rank ?? 1) - (right.rank ?? 1);
  if (rank !== 0) {
    return rank;
  }
  return left.name < right.name ? -1 : left.name > right.name ? 1 : 0;
}
